import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import styles from "./LoadingArticle.module.css";

export const LoadingArticle = () => {
  return (
    <div className={styles["loadingArticle"]}>
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className={styles["loadingArticleInner"]}>
          <FixaSkeleton width="73px" height="73px" />
          <div className={styles["loadingArticleDetails"]}>
            <FixaSkeleton width="79px" height="16px" />
            <FixaSkeleton width="69px" height="16px" />
            <FixaSkeleton width="200px" height="16px" />
          </div>
        </div>
      ))}
    </div>
  );
};
